<div class="rich-text-presenter">
  <div [innerHTML]="richTextHtml"></div>
</div>
